import { addArtToCart, addWallToCart } from 'arts/actions/cart_items';

export const addToCart = (index) => (dispatch, getState) => {
  const { canvas: { works }, workDetails } = getState();
  const {
    workId, workSizeId, frameId, nonGlare
  } = works[index];
  const { paperId } = workDetails[workId].workSizes.find((ws) => ws.id === workSizeId);
  dispatch(addArtToCart({
    frameId, paperId, workId, nonGlare
  }));
};

export const addCurrentWallToCart = () => (dispatch, getState) => {
  const { canvas: { wallId } } = getState();
  dispatch(addWallToCart(wallId));
};
